import React, { useCallback, useEffect, useRef, useState } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import PropTypes from 'prop-types'
import { useMediaQuery } from '@uidotdev/usehooks'
// components
import Card from './Card'
import Button from '../../shared/components/Button/Button'
// styles
import './styles.scss'

const chunkArray = (array, chunkSize) => {
  const chunks = []
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize))
  }
  return chunks
}

const CustomCarousel = ({ posts = [], showRedirectButton, redirectButton }) => {
  const { title, url, target } = redirectButton
  const isMobile = useMediaQuery('only screen and (max-width: 1100px)')
  const [size, setSize] = useState(1)
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: 'start',
    containScroll: 'trimSnaps',
    slidesToScroll: 1,
    loop: true,
  })

  const prevRef = useRef(null)
  const nextRef = useRef(null)

  const scrollPrev = useCallback(() => {
    emblaApi && emblaApi.scrollPrev()
  }, [emblaApi])

  const scrollNext = useCallback(() => {
    emblaApi && emblaApi.scrollNext()
  }, [emblaApi])

  useEffect(() => {
    if (isMobile) {
      setSize(3)
    } else {
      setSize(1)
    }
  }, [isMobile])

  const crunks = chunkArray(posts || [], size)

  return (
    <div className="custom-carousel">
      <div className="custom-carousel__viewport" ref={emblaRef}>
        <div className="custom-carousel__container">
          {crunks.map((postArray, index) => (
            <div className="custom-carousel__slide custom-carousel__slide--stack" key={index}>
              {postArray.map((post) => (
                <Card
                  key={post.id}
                  imageSrc={post.featuredImage}
                  title={post.title}
                  description={post.excerpt}
                  link={post.url}
                  target="_parent"
                />
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="embla__footer">
        {showRedirectButton ? (
          <Button
            className="btn-redirect"
            name={title}
            link={url}
            type="button"
            showLabel={true}
            target={target}
            light={true}
            variant="filled"
          />
        ) : (
          <div className="col-span-6" />
        )}
        <div className="embla__buttons">
          <Button
            className="embla__prev"
            action={scrollPrev}
            ref={prevRef}
            type="icon"
            icon="ArrowLeft"
            iconFill="transparent"
            iconStroke="#1B1F24"
            strokeCircle="#1B1F24"
          />
          <Button
            className="embla__next"
            action={scrollNext}
            ref={nextRef}
            type="icon"
            icon="ArrowRight"
            iconFill="transparent"
            iconStroke="#1B1F24"
            strokeCircle="#1B1F24"
          />
        </div>
      </div>
    </div>
  )
}

CustomCarousel.propTypes = {
  posts: PropTypes.array,
  kind_of_news: PropTypes.string,
}

export default CustomCarousel
